import { publicTimelineView } from './publicTimelineView'
import { timelineView } from './timelineView'

export function buildActivityTimelineViews({
  activity,
  workStatus,
  runId,
  publicActivity,
}) {
  const view = timelineView(workStatus, activity, runId)
  const publicView = publicTimelineView({
    phases: publicActivity.phases,
    historySteps: publicActivity.steps,
    activity,
  })
  return { view, publicView, hasPublicTimeline: publicView.phases.length > 0 }
}
